import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { TopNavigationModule } from '../../components/top-navigation/top-navigation.module';
import { SearchCollaboratorModule } from '../../components/search-collaborator/search-collaborator.module';
import { InfoModalModule } from '../../components/info-modal/info-modal.module';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { EmployeeRequestsRoutingModule } from './employee-requests-routing.module';
import { EmployeeRequestsComponent } from './employee-requests.component';
import { UiButtonModule } from '@unico-people/shared/ui-button';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { FeatureStatusErrorModule } from '@unico-people/shared/dashboard/feature-status-error';
import { RequestListModule } from '../../components/request-list/request-list.module';
import { AlertModule } from '../../components/alert';
import { FeaturePaginationModule } from '@unico-people/shared/dashboard/feature-pagination';
import { NgxPaginationModule } from 'ngx-pagination';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [EmployeeRequestsComponent],
  imports: [
    CommonModule,
    TopNavigationModule,
    SearchCollaboratorModule,
    InfoModalModule,
    EmployeeRequestsRoutingModule,
    MatCardModule,
    MatDividerModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatButtonModule,
    MatNativeDateModule,
    MatDialogModule,
    UiButtonModule,
    MatTabsModule,
    MatIconModule,
    MatTableModule,
    FeatureStatusErrorModule,
    RequestListModule,
    AlertModule,
    FeaturePaginationModule,
    NgxPaginationModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class EmployeeRequestsModule {}
